/**
 * Cap on the number of collection names rendered inline before the surplus is
 * collapsed into a `+N more` affordance — a `+N more` chip in `ReferenceCard`'s
 * `CollectionsRow`, a `+N more` text suffix in `LibrarySearchBlock`'s
 * per-result caption.
 *
 * Chosen to align with the backend's `_MAX_COLLECTIONS_SHOWN = 4`-class cap on
 * the LLM-facing `Collections:` annotation while still allowing a heavy
 * power-user case to render a meaningful subset before truncation kicks in.
 * Hoisted into this shared module so the two chat reference surfaces can't
 * drift out of sync.
 */
export const COLLECTIONS_MAX_VISIBLE = 10;
